import { render } from "./KaikuAgree.vue?vue&type=template&id=5bec75d2&scoped=true&ts=true"
import script from "./KaikuAgree.vue?vue&type=script&lang=ts"
export * from "./KaikuAgree.vue?vue&type=script&lang=ts"

import "./KaikuAgree.vue?vue&type=style&index=0&id=5bec75d2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bec75d2"]])

export default __exports__